import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import MobileTabBar from '@/components/feature/MobileTabBar';

interface Props {
  children: React.ReactNode;
}

export function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, search]);
  return null;
}

export default function SiteLayout({ children }: Props) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />
      <MobileTabBar />
    </div>
  );
}